import { render, staticRenderFns } from "./YHStaffManagement.vue?vue&type=template&id=50aeb196&scoped=true"
import script from "./YHStaffManagement.vue?vue&type=script&lang=js"
export * from "./YHStaffManagement.vue?vue&type=script&lang=js"
import style0 from "./YHStaffManagement.vue?vue&type=style&index=0&id=50aeb196&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aeb196",
  null
  
)

export default component.exports